import React, { useState, useEffect } from "react";

// const URL = "http://localhost:5000/";
const URL = "https://skp-backend-619387713761.asia-south1.run.app/"

// test
const AdminPage = () => {
  const [collections, setCollections] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [newCollection, setNewCollection] = useState({
    title: "",
    description: "",
  });
  const [newCollectionImage, setNewCollectionImage] = useState(null);

  const [newGalleryImage, setNewGalleryImage] = useState(null);

  // Product form states
  const [productForm, setProductForm] = useState({
    name: "",
    description: "",
  });
  const [productImage, setProductImage] = useState(null);
  const [activeCollectionId, setActiveCollectionId] = useState(null);

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [loginError, setLoginError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;

    const token = localStorage.getItem("accessToken");
    const headers = { Authorization: `Bearer ${token}` };

    fetch(`${URL}collections`, { headers })
      .then((res) => res.json())
      .then(setCollections)
      .catch(console.error);

    fetch(`${URL}gallery`, { headers })
      .then((res) => res.json())
      .then(setGallery)
      .catch(console.error);
  }, [isAuthenticated]);

  const handleLogin = () => {
    setLoginError("");
    fetch(`${URL}login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password: passwordInput }),
    })
      .then(async (res) => {
        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(errorData.error || "Login failed");
        }
        return res.json();
      })
      .then((data) => {
        localStorage.setItem("accessToken", data.access_token);
        setIsAuthenticated(true);
        setPasswordInput("");
      })
      .catch((err) => {
        setLoginError(err.message);
      });
  };

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    setIsAuthenticated(false);
  };

  const getAuthHeaders = () => {
    const token = localStorage.getItem("accessToken");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  // Helper to check if file is video by extension
  const isVideoFile = (filename) => {
    return /\.(mp4|mov|avi|mkv|webm)$/i.test(filename);
  };

  // --- Collection CRUD ---
  const addCollection = () => {
    if (!newCollection.title || !newCollectionImage) {
      alert("Title and image/video are required");
      return;
    }

    const formData = new FormData();
    formData.append("title", newCollection.title);
    formData.append("description", newCollection.description);
    formData.append("image", newCollectionImage);

    fetch(`${URL}collections`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        setCollections((prev) => [...prev, data]);
        setNewCollection({ title: "", description: "" });
        setNewCollectionImage(null);
      })
      .catch(console.error);
  };

  const deleteCollection = (id) => {
    fetch(`${URL}collections/${id}`, {
      method: "DELETE",
      headers: getAuthHeaders(),
    }).then(() => setCollections((prev) => prev.filter((c) => c.id !== id)));
  };

  // --- Product CRUD ---
  const addProduct = (collectionId) => {
    if (!productForm.name || !productImage) {
      alert("Name and image/video are required");
      return;
    }

    const formData = new FormData();
    formData.append("name", productForm.name);
    formData.append("description", productForm.description);
    formData.append("image", productImage);

    fetch(`${URL}collections/${collectionId}/products`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        setCollections((prev) =>
          prev.map((c) =>
            c.id === collectionId ? { ...c, products: [...c.products, data] } : c
          )
        );
        setProductForm({ name: "", description: "" });
        setProductImage(null);
        setActiveCollectionId(null);
      })
      .catch(console.error);
  };

  const deleteProduct = (collectionId, productId) => {
    fetch(`${URL}collections/${collectionId}/products/${productId}`, {
      method: "DELETE",
      headers: getAuthHeaders(),
    }).then(() => {
      setCollections((prev) =>
        prev.map((c) =>
          c.id === collectionId
            ? { ...c, products: c.products.filter((p) => p.id !== productId) }
            : c
        )
      );
    });
  };

  // --- Gallery CRUD ---
  const addGalleryImage = () => {
    if (!newGalleryImage) {
      alert("Select an image or video");
      return;
    }

    const formData = new FormData();
    formData.append("image", newGalleryImage);

    fetch(`${URL}gallery`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        setGallery((prev) => [...prev, data.url]);
        setNewGalleryImage(null);
      })
      .catch(console.error);
  };

  const deleteGalleryImage = (index) => {
    fetch(`${URL}gallery/${index}`, {
      method: "DELETE",
      headers: getAuthHeaders(),
    }).then(() => setGallery((prev) => prev.filter((_, i) => i !== index)));
  };

  if (!isAuthenticated) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4">
        <h1 className="text-3xl font-bold mb-6">Admin Login</h1>
        <input
          type="password"
          placeholder="Enter password"
          className="border px-4 py-3 rounded-md w-full max-w-sm mb-4 focus:outline-none focus:ring-2 focus:ring-green-500"
          value={passwordInput}
          onChange={(e) => setPasswordInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleLogin();
          }}
        />
        <button
          className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-md shadow-md transition"
          onClick={handleLogin}
        >
          Login
        </button>
        {loginError && (
          <p className="text-red-600 mt-4 font-semibold">{loginError}</p>
        )}
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto p-6 space-y-8">
      <div className="flex justify-between items-center">
        <h1 className="text-4xl font-extrabold text-gray-800">Admin Panel</h1>
        <button
          onClick={handleLogout}
          className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md shadow-md transition"
        >
          Logout
        </button>
      </div>

      {/* Collections */}
      <section className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-semibold mb-4 border-b pb-2">Collections</h2>

        <div className="flex flex-col md:flex-row md:items-center gap-4 mb-6">
          <input
            placeholder="Title"
            value={newCollection.title}
            onChange={(e) =>
              setNewCollection({ ...newCollection, title: e.target.value })
            }
            className="flex-1 border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-500"
          />
          <input
            type="file"
            accept="image/*,video/*"
            onChange={(e) => setNewCollectionImage(e.target.files[0])}
            className="border border-gray-300 rounded-md px-4 py-2 cursor-pointer"
          />
        </div>
        <textarea
          placeholder="Description"
          value={newCollection.description}
          onChange={(e) =>
            setNewCollection({ ...newCollection, description: e.target.value })
          }
          rows={3}
          className="w-full border border-gray-300 rounded-md px-4 py-3 resize-none focus:outline-none focus:ring-2 focus:ring-green-500 mb-4"
        />
        <button
          onClick={addCollection}
          className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-md shadow-md transition"
        >
          Add Collection
        </button>

        {collections.length === 0 && (
          <p className="mt-4 text-gray-600">No collections yet.</p>
        )}

        {collections.map((c) => (
          <div
            key={c.id}
            className="border border-gray-300 rounded-lg p-6 mt-8 shadow-sm hover:shadow-md transition"
          >
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="flex items-center gap-6">
                {isVideoFile(c.image) ? (
                  <video
                    src={`${URL}${c.image}`}
                    controls
                    className="w-32 h-32 rounded-md border border-gray-200 object-cover"
                  />
                ) : (
                  <img
                    src={`${URL}${c.image}`}
                    alt={c.title}
                    className="w-32 h-32 object-cover rounded-md border border-gray-200"
                  />
                )}
                <div>
                  <h3 className="text-xl font-semibold">{c.title}</h3>
                  <p className="text-gray-700 mt-1 whitespace-pre-line">
                    {c.description || "No description"}
                  </p>
                </div>
              </div>
              <button
                className="bg-red-600 hover:bg-red-700 text-white rounded-md px-4 py-2 font-semibold shadow-md transition self-start md:self-auto"
                onClick={() => deleteCollection(c.id)}
                aria-label={`Delete collection ${c.title}`}
              >
                Delete Collection
              </button>
            </div>

            {/* Products */}
            <div className="mt-6">
              <h4 className="text-lg font-semibold mb-3">Products</h4>
              {c.products.length === 0 ? (
                <p className="text-gray-600">No products in this collection.</p>
              ) : (
                <ul className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {c.products.map((p) => (
                    <li
                      key={p.id}
                      className="border rounded-md p-3 flex items-center gap-3 shadow-sm hover:shadow-md transition"
                    >
                      {isVideoFile(p.image) ? (
                        <video
                          src={`${URL}${p.image}`}
                          controls
                          className="w-16 h-16 rounded-md border border-gray-200 object-cover"
                        />
                      ) : (
                        <img
                          src={`${URL}${p.image}`}
                          alt={p.name}
                          className="w-16 h-16 object-cover rounded-md border border-gray-200 bg-green-500"
                        />
                      )}
                      <div className="flex-1">
                        <p className="font-semibold">{p.name}</p>
                        <p className="text-gray-600 text-sm whitespace-pre-line">
                          {p.description || "No description"}
                        </p>
                      </div>
                      <button
                        className="bg-red-500 hover:bg-red-600 text-white rounded px-2 py-1 font-semibold shadow transition"
                        onClick={() => deleteProduct(c.id, p.id)}
                        aria-label={`Delete product ${p.name}`}
                      >
                        X
                      </button>
                    </li>
                  ))}
                </ul>
              )}

              {/* Add product form */}
              {activeCollectionId === c.id ? (
                <div className="mt-4 border border-gray-300 rounded-md p-4 bg-gray-50">
                  <h5 className="font-semibold mb-2">Add New Product</h5>
                  <input
                    placeholder="Name"
                    value={productForm.name}
                    onChange={(e) =>
                      setProductForm({ ...productForm, name: e.target.value })
                    }
                    className="w-full border border-gray-300 rounded-md px-3 py-2 mb-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                  <input
                    placeholder="Description"
                    value={productForm.description}
                    onChange={(e) =>
                      setProductForm({
                        ...productForm,
                        description: e.target.value,
                      })
                    }
                    className="w-full border border-gray-300 rounded-md px-3 py-2 mb-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                  <input
                    type="file"
                    accept="image/*,video/*"
                    onChange={(e) => setProductImage(e.target.files[0])}
                    className="mb-3"
                  />
                  <div className="flex gap-4">
                    <button
                      onClick={() => addProduct(c.id)}
                      className="bg-green-600 hover:bg-green-700 text-white rounded-md px-4 py-2 font-semibold shadow-md transition flex-1"
                    >
                      Save Product
                    </button>
                    <button
                      onClick={() => setActiveCollectionId(null)}
                      className="bg-gray-300 hover:bg-gray-400 rounded-md px-4 py-2 font-semibold transition flex-1"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                <button
                  className="mt-4 bg-blue-600 hover:bg-blue-700 text-white rounded-md px-4 py-2 font-semibold shadow-md transition"
                  onClick={() => setActiveCollectionId(c.id)}
                >
                  Add Product
                </button>
              )}
            </div>
          </div>
        ))}
      </section>

      {/* Gallery */}
      <section className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-semibold mb-4 border-b pb-2">Gallery</h2>

        <div className="flex items-center gap-4 mb-6">
          <input
            type="file"
            accept="image/*,video/*"
            onChange={(e) => setNewGalleryImage(e.target.files[0])}
            className="border border-gray-300 rounded-md px-4 py-2 cursor-pointer"
          />
          <button
            onClick={addGalleryImage}
            className="bg-green-600 hover:bg-green-700 text-white rounded-md px-6 py-3 font-semibold shadow-md transition"
          >
            Add Image/Video
          </button>
        </div>

        {gallery.length === 0 && (
          <p className="text-gray-600">No gallery images/videos added yet.</p>
        )}

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {gallery.map((fileUrl, i) => (
            <div
              key={i}
              className="relative border rounded-md overflow-hidden shadow-sm hover:shadow-md transition"
            >
              {isVideoFile(fileUrl) ? (
                <video
                  src={`${URL}${fileUrl}`}
                  controls
                  className="w-full h-40 object-cover"
                />
              ) : (
                <img
                  src={`${URL}${fileUrl}`}
                  alt={`Gallery ${i + 1}`}
                  className="w-full h-40 object-cover"
                />
              )}
              <button
                className="absolute top-1 right-1 bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded-md font-semibold shadow"
                onClick={() => deleteGalleryImage(i)}
                aria-label={`Delete gallery image/video ${i + 1}`}
              >
                X
              </button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AdminPage;
